module.exports = __webpack_public_path__ + "img/user-profile.bea84f62.png";